"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COLOR_WHITE = exports.DEFAULT_BORDER = exports.FOOTER_HEIGHT = void 0;
var FOOTER_HEIGHT = "100px";
exports.FOOTER_HEIGHT = FOOTER_HEIGHT;

var DEFAULT_BORDER = function DEFAULT_BORDER() {
  var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var left = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return "\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.09);\n\n  border-color: rgba(26, 28, 34, 0.1);\n  border-style: solid;\n\n  border-width: ".concat(top, "px ").concat(right, "px ").concat(bottom, "px ").concat(left, "px;\n");
};

exports.DEFAULT_BORDER = DEFAULT_BORDER;
var COLOR_WHITE = '#ffffff';
exports.COLOR_WHITE = COLOR_WHITE;
var _default = {
  FOOTER_HEIGHT: FOOTER_HEIGHT,
  DEFAULT_BORDER: DEFAULT_BORDER,
  COLOR_WHITE: COLOR_WHITE
};
exports["default"] = _default;